dcyAngular.internalDefine('devel/modules/components/search_bar/BlogSearchManager',["require","exports","./SearchManager"],function(require,exports,SearchManager_1){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default=class extends SearchManager_1.SearchManager{constructor(attributes,tags){super(attributes,tags)}}});
//# sourceMappingURL=BlogSearchManager.js.map
;
